var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"splashscreen"}},[_c('img',{attrs:{"id":"logo","src":"/all/tecnograph_logo_bianco_con_scritta.svg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }